<template>
  <div class="footer text-center mt-2">
    &copy; {{new Date().getFullYear()}} <strong>Stream Tales</strong> created by <a href="https://altoar.io" target="_blank">Altoar.io</a> | 
    <a href="https://altoar.io/terms" target="_blank">Terms</a> | 
    <a href="https://altoar.io//privacy" target="_blank">Privacy</a>
  </div>
</template>

<script>
export default {

  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  margin-bottom: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue